import { Card, CardContent, Typography, styled, Box } from '@mui/material';

const NftCard = styled(Card)(({ theme }) => ({
  background: `linear-gradient(145deg, ${theme.palette.background.paper} 0%, #1e075a 100%)`,
  borderRadius: '16px',
  border: '1px solid',
  borderColor: theme.palette.primary.main,
  boxShadow: `0 0 15px ${theme.palette.primary.main}40`,
  transition: 'all 0.3s ease',
  '&:hover': {
    transform: 'translateY(-5px)',
    boxShadow: `0 0 25px ${theme.palette.primary.main}80`,
  },
  position: 'relative',
  overflow: 'hidden',
  '&::before': {
    content: '""',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    height: '4px',
    background: `linear-gradient(90deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
  },
}));

const ValueText = styled(Typography)(({ theme }) => ({
  background: `-webkit-linear-gradient(${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  fontWeight: 'bold',
}));

export const StatWidget = ({ title, value, change }: { title: string; value: number; change: string }) => {
  return (
    <NftCard className='pulse-effect'>
      <CardContent>
        <Typography variant="h6" gutterBottom sx={{ opacity: 0.8 }}>
          {title}
        </Typography>
        <ValueText variant="h3">
          {value.toLocaleString()}
        </ValueText>
        <Box sx={{ display: 'flex', alignItems: 'center', mt: 1 }}>
          <Typography
            variant="body2"
            sx={{
              color: change.startsWith('+') ? '#4caf50' : '#f44336',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            {change} за месяц
          </Typography>
        </Box>
      </CardContent>
    </NftCard>
  );
};